import Hero from "@/components/Hero";
import DestinationPills from "@/components/DestinationPills";
import Marquee from "@/components/Marquee";
import HomePhotoPreview from "@/components/HomePhotoPreview";
import YolandaBand from "@/components/YolandaBand";
import { useSite } from "@/Layout";

export default function Home() {
  const { config, ratingMeta } = useSite();

  return (
    <div data-testid="home-page">
      <Hero config={config} ratingMeta={ratingMeta} />
      <Marquee />
      <DestinationPills />
      <HomePhotoPreview />
      <YolandaBand />
    </div>
  );
}
